<template>
  <img :src="logoSrc">
</template>

<script>
/* eslint-disable vue/require-prop-types */
const amex = require('assets/images/credit-card-brands/amex-nobg.svg');
const discover = require('assets/images/credit-card-brands/discover-nobg.svg');
const elo = require('assets/images/credit-card-brands/elo-nobg.svg');
const hipercard = require('assets/images/credit-card-brands/hipercard-nobg.svg');
const mastercard = require('assets/images/credit-card-brands/mastercard-nobg.svg');
const visa = require('assets/images/credit-card-brands/visa-nobg.svg');
const defaultLogo = require('assets/images/credit-card-brands/credit-card.svg');

const brandToImgMap = {
  amex, discover, elo, hipercard, mastercard, visa, defaultLogo,
};
export default {
  props: ['brand'],
  data() {
    return {
      logoSrc: null,
    };
  },
  mounted() {
    this.updateLogoSrc();
  },
  methods: {
    updateLogoSrc() {
      if (brandToImgMap[this.brand] === undefined) {
        this.logoSrc = brandToImgMap.defaultLogo;
      } else {
        this.logoSrc = brandToImgMap[this.brand];
      }
    },
  },
  watch: {
    brand() {
      this.updateLogoSrc();
    },
  },
};
</script>
